import { Widget } from "./widget.js";

export class Dialog extends Widget
{
    constructor({
        contents,
        onclose,
        ...rest
    })
    {
        super({
            html: `
    <div class="dialog">
        <div class=dialog-contents>
        ${contents}
        </div>
    </div>
`, ...rest});
        this.onclose = onclose;

        this.root.addEventListener("click", (e) => {
            // Backdrop clicks:
            if(e.target === this.root)
                this.close();
        }, { signal: this._signal });
    }

    close()
    {
        this.root.remove();
        this.onclose?.();
    }
}
